import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("刷新")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'GET/labor_contracts/diff': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let detailsObj: any = reactive({})
const searchHandle = () => {
  fetchData().then((rep) => {
    let { contractNumber, diffNumber, existUserNumber } = rep
    Object.assign(detailsObj, { contractNumber, diffNumber, existUserNumber })
  })
}
searchHandle()

const searchConfig = ref([])

// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => { }

// 删除
const delHandle = (row: any) => { }


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      icon: "refresh",
      type: "info",
      onClick: searchHandle,
      class: "mb-10"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_descriptions, {
      title: "",
      border: "",
      style: {"width":"40%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, { label: "在职总人数" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(detailsObj).existUserNumber), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "劳动合同数" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(detailsObj).contractNumber), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "差异值" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(detailsObj).diffNumber), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 20 + "px",
      style: {"width":"40%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "英文名",
          prop: "alias",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})